import { Component, ViewChild, OnInit } from '@angular/core'
import { DateHelper } from '@mprep/shared/lib/helpers'
import { AppContext } from '@mprep/shared'
import { LsacService } from '@mprep/shared/data/services'
import { LSAC_ACCOUNT_TYPES, LSAC_STORE_URL, NavigationService } from 'app/shared'
import { ResourceGroupsComponent } from 'app/shared/components/resource-groups'
import { LsacResult, ResourceType } from '@mprep/shared/data/models'

@Component({
  selector: 'mp-lsac',
  templateUrl: './lsac.html',
  styleUrls: ['./lsac.scss']
})
export class LsacComponent implements OnInit {
  @ViewChild(ResourceGroupsComponent)
  resourceGroupsComponent: ResourceGroupsComponent
  public account = {}
  public testResults = []
  PreptestResourceType = ResourceType.LsacPreptest

  constructor(
    private _lsacService: LsacService,
    private _appContext: AppContext,
    private _dateHelper: DateHelper,
    private _navigationService: NavigationService
  ) {}

  public ngOnInit() {
    this.loadAccountInfo()
  }

  public signUp(type) {
    let productOption = {
      name: LSAC_ACCOUNT_TYPES[type]
    }

    this._lsacService.signUp(this._appContext.currentUser, productOption).subscribe((data: LsacResult) => {
      this.loadAccountInfo()
    })
  }

  public purchaseInStore() {
    this._navigationService.navigateToUrl(LSAC_STORE_URL)
  }

  public hasPrepTestAccess(): boolean {
    return !this.isAccountEmpty() && this.isLinked() && this.isPrepPlus()
  }

  public hasSignUpModal(): boolean {
    return !this.isAccountEmpty() && !this.isAccountLinkPersisted()
  }

  public hasNotLinkedPersonalAccount(): boolean {
    return !this.isAccountEmpty() && this.isNotLinked() && !this.isPrepPlusProvided()
  }

  public hasInactiveProvidedPrepPlus() {
    return this.isPrepPlusProvided() && !this.isPrepPlusRedeemed()
  }

  public hasAccountModal(): boolean {
    return !this.isAccountEmpty() && this.isAccountLinkPersisted()
  }

  public hasLinkedFreePersonalAccount() {
    return this.isLinked() && !this.isPrepPlus() && !this.isPrepPlusProvided()
  }

  public isLinked(): boolean {
    return this.account['linked'] == true
  }

  public isPrepPlusProvided(): boolean {
    return this.account['isPrepPlusIncludedFromVendor'] == true
  }

  public isPrepPlusRedeemed(): boolean {
    return this.account['wasPrepPlusRedeemed'] == true
  }

  public getSubscriptionLabel() {
    if (this.isPrepPlusProvided()) {
      return 'Prep+ (through Manhattan Prep)'
    }
    return this.isPrepPlus() ? 'Prep+ (through LSAC)' : 'Free'
  }

  private loadAccountInfo() {
    this._lsacService.getAccount(this._appContext.currentUser).subscribe((accountData: LsacResult) => {
      this.account = accountData.getAccount()
      if (this.isAccountLinkPersisted()) {
        this._lsacService.getTestResults(this._appContext.currentUser).subscribe((testResultData: LsacResult) => {
          this.testResults = testResultData.getTestResults()
        })
      }
    })
  }

  private isAccountEmpty(): boolean {
    return Object.keys(this.account).length == 0
  }

  private isPrepPlus(): boolean {
    return this.account['subscriptionType'] == 'PrepPlus'
  }

  private isAccountLinkPersisted(): boolean {
    return this.account['accountLinkPersisted']
  }

  private isNotLinked(): boolean {
    return this.account['linked'] == false
  }

  private formatDate(string) {
    return this._dateHelper.get(new Date(string)).format('YYYY/MM/DD')
  }

  private formatDateTime(string) {
    return this._dateHelper.get(new Date(string)).format('hh:mm A')
  }
}



// WEBPACK FOOTER //
// ./src/app/lsac/lsac.component.ts